const custom_profile_fields = {
    /** UNTRANSLATED */
    entity_not_exists_with_names: 'Cannot find entities with the given names: {{names}}',
    invalid_min_max_input: 'Entrada mínima ou máxima inválida.',
    invalid_options: 'Opções de campo inválidas.',
    invalid_regex_format: 'Formato de regex inválido.',
    invalid_address_parts: 'Partes do endereço inválidas.',
    invalid_fullname_parts: 'Partes do nome completo inválidas.',
    name_exists: 'Já existe um campo com o nome fornecido.',
    conflicted_sie_order: 'Valor de ordem do campo em conflito para a experiência de início de sessão.',
    /** UNTRANSLATED */
    invalid_name: 'Invalid field name, only letters or numbers are allowed, case sensitive.',
};
export default Object.freeze(custom_profile_fields);
